import { useTranslation } from 'react-i18next';

const certItems = [
  { icon: 'ri-award-fill', titleKey: 'cert1_title', subKey: 'cert1_sub', descKey: 'cert1_desc', yearKey: 'cert1_year', color: '#C8714A' },
  { icon: 'ri-leaf-fill', titleKey: 'cert2_title', subKey: 'cert2_sub', descKey: 'cert2_desc', yearKey: 'cert2_year', color: '#5a8a5a' },
  { icon: 'ri-shield-check-fill', titleKey: 'cert3_title', subKey: 'cert3_sub', descKey: 'cert3_desc', yearKey: 'cert3_year', color: '#4a7a9b' },
  { icon: 'ri-global-fill', titleKey: 'cert4_title', subKey: 'cert4_sub', descKey: 'cert4_desc', yearKey: 'cert4_year', color: '#9b6a4a' },
];

export default function CertificatesSection() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-24 px-6 md:px-10 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <div className="text-[#C8714A] text-xs font-semibold tracking-widest uppercase mb-3">
            {t('cert_label')}
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a1a1a] mb-3">{t('cert_title')}</h2>
          <p className="text-[#888] text-sm max-w-md mx-auto">
            {t('cert_desc')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {certItems.map((cert) => (
            <div
              key={cert.titleKey}
              className="group p-6 rounded-2xl border border-[#f0ebe4] bg-[#faf8f5] hover:border-[#C8714A]/30 transition-all duration-300"
            >
              <div
                className="w-12 h-12 flex items-center justify-center rounded-xl mb-4"
                style={{ backgroundColor: `${cert.color}15` }}
              >
                <i className={`${cert.icon} text-xl`} style={{ color: cert.color }}></i>
              </div>
              <div className="text-base font-bold text-[#1a1a1a] mb-0.5">{t(cert.titleKey)}</div>
              <div className="text-xs text-[#C8714A] font-medium mb-3">{t(cert.subKey)}</div>
              <p className="text-xs text-[#888] leading-relaxed mb-4">{t(cert.descKey)}</p>
              <div className="text-xs text-[#bbb] flex items-center gap-1">
                <i className="ri-calendar-line text-xs"></i>
                {t(cert.yearKey)}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}